import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css"; // reuse login page styles
import "./SignUpPage.css";

const SignUpPage: React.FC = () => {
    const navigate = useNavigate();

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [errorField, setErrorField] = useState<
        "fullName" | "email" | "username" | "password" | "confirmPassword" | null
    >(null);


    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL;

    const handleRegister = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage("");
        setErrorField(null);

        // --- Frontend validation ---
        // Full name must have at least, say, 5 characters (first + last name minimum)
        if (fullName.trim().length < 5) {
            setErrorField("fullName");
            setMessage("Full name must include first and last name");
            return;
        }
        // Username must be 3�20 characters, letters or numbers only
        if (!/^[\w]{3,20}$/.test(username)) {
            setErrorField("username");
            setMessage("Username must be 3�20 characters, letters or numbers only");
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setErrorField("email");
            setMessage("Email is not valid");
            return;
        }
        if (password.length < 6) {
            setErrorField("password");
            setMessage("Password must be at least 6 characters");
            return;
        }
        if (password !== confirmPassword) {
            setErrorField("confirmPassword");
            setMessage("Passwords do not match");
            return;
        }

        try {
            const res = await fetch(`${API_URL}/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ fullName, email, username, password }),
            });

            const data = await res.json();

            if (res.ok) {
                setMessage("User created successfully! Redirecting to login...");
                setTimeout(() => navigate("/login"), 2000);
            } else {
                // Highlight the field if backend specifies
                if (data.field) setErrorField(data.field);
                setMessage(data.message || "Registration failed");
            }
        } catch (error) {
            setMessage("Network error, please try again");
        }
    };

    return (
        <div className="login-page">
            <div className="signup-form-wrapper" style={{ padding: "0px 25px" }}>
                <img src={`${process.env.PUBLIC_URL}/eda_signUp_logo.png`} alt="Logo" className="login-logo" />

              {/*  <h2 className="signup-heading">Sign Up</h2>*/}

                <div className="signup-form-container">
                    <form onSubmit={handleRegister} className="signup-form">
                        <input
                            type="text"
                            placeholder="Full Name"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                            className={errorField === "fullName" ? "input-error" : ""}
                        />
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className={errorField === "email" ? "input-error" : ""}
                        />
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className={errorField === "username" ? "input-error" : ""}
                        />
                        {/* Password field with custom eye icons */}
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}  // <-- dynamic type
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className={errorField === "password" ? "input-error" : ""}
                            />
                            <span className="password-eye" onClick={() => setShowPassword(!showPassword)}>
                                <img
                                    src={
                                        showPassword
                                            ? `${process.env.PUBLIC_URL}/eye-openend.svg`
                                            : `${process.env.PUBLIC_URL}/eye-closed.svg`
                                    }
                                    alt={showPassword ? "Hide password" : "Show password"}
                                />
                            </span>
                        </div>

                        {/* Confirm Password field with custom eye icons */}
                        <div className="password-wrapper">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Retype Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                className={errorField === "confirmPassword" ? "input-error" : ""}
                            />
                            <span className="password-eye" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                <img
                                    src={
                                        showConfirmPassword
                                            ? `${process.env.PUBLIC_URL}/eye-openend.svg`
                                            : `${process.env.PUBLIC_URL}/eye-closed.svg`
                                    }
                                    alt={showConfirmPassword ? "Hide password" : "Show password"}
                                />
                            </span>
                        </div>

                        <button type="submit">Sign Up</button>
                        {message && <p className="login-error">{message}</p>}
                    </form>
                
                </div>
            </div>
        </div>
    );
};

export default SignUpPage;
